const CatalogueCard = ({ item }) => {
    return (
      <div className="  rounded-lg shadow-md p-4 bg-white flex flex-col items-center">
        {/* <a
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
        >
          <img src="/images/sub-product.png" alt="sub product image"></img>
          View PDF
        </a>
        <div className="text-lg font-semibold">{item.name}</div> */}
        <div class="row gutter-7">
          <div class="col-lg-12">
            <div class="sub-product-div">
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
              >
                <img src="/images/sub-product.png" alt="sub product image" />
              </a>
              <h6> {item.name}</h6>
            </div>
          </div>
        </div>
      </div>
    );
};

export default CatalogueCard;
